import { render, staticRenderFns } from "./defaultheader.vue?vue&type=template&id=dfa4f4d8&"
import script from "./defaultheader.vue?vue&type=script&lang=js&"
export * from "./defaultheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports